import getCustomField from '@webapp-next/lib/request/webapp/schedule/custom-fields/get-custom-fields';
import getCustomFieldValue from '@webapp-next/lib/request/webapp/schedule/custom-fields/get-custom-field-value';
import { fetchManagedAreas } from '@webapp-next/lib/request/webapp/schedule/areas/areas';
import deleteShiftCall from '@webapp-next/modules/schedule/composables/roster/delete-shift';

const customFields = {
  getCustomField,
  getCustomFieldValue,
};

export default {
  customFields,
  fetchManagedAreas,
  deleteShiftCall,
};
